export function getUrlStringFromAdditionParameterList(additionalParams: any){
    if (additionalParams.length > 0) {
        const paramsString: string = additionalParams
            .map((additionalParam: any) => {
                if (Array.isArray(additionalParam.value)) {
                    return additionalParam.value.map((item: any) => `${additionalParam.name}=${item}`).join('&')
                }

                return `${additionalParam.name}=${additionalParam.value}`
            })
            .join('&')

        return paramsString
    }

    return undefined
}